import useSWRImmutable from 'swr/immutable';
import { fetcherSS } from '@/modules/api';

export interface IAuthProvider {
  name: string;
  url: string;
}

export const useAuthProviders = () => {
  const {
    data = [],
    error,
    isLoading,
  } = useSWRImmutable<IAuthProvider[]>('/info/auth_providers', (url: string) =>
    fetcherSS(url, { headers: { 'X-Content-Policy': '4' } })
  );

  return {
    data,
    error,
    isLoading,
  };
};
